import { render, staticRenderFns } from "./BaseMessage.vue?vue&type=template&id=2ce33d42"
import script from "./BaseMessage.vue?vue&type=script&lang=js"
export * from "./BaseMessage.vue?vue&type=script&lang=js"
import style0 from "./BaseMessage.vue?vue&type=style&index=0&id=2ce33d42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports